import React from "react";
import Field from "../shared/Field";
import { inputStyle } from "../shared/inputStyle";
import { formatAmountInput } from "../utils/format";

export default function SpecializedForm({
  unitLabel,
  specializedAmount,
  setSpecializedAmount,
}) {
  return (
    <Field label={`مابه‌الاختلاف مالی (${unitLabel}) — فقط جهت محاسبه تمبر`}>
      <input
        type="text"
        inputMode="numeric"
        value={specializedAmount}
        onChange={(e) =>
          setSpecializedAmount(formatAmountInput(e.target.value))
        }
        placeholder="مثلاً 600,000,000"
        className="input"
        style={inputStyle}
      />
    </Field>
  );
}
